import moment from 'moment';
import { HttpClient } from '@/shared/lib/http-client';

export const fetchProlongationOrders = async () => {
  const FIRST_PAGE = 1;
  const ITEMS_PER_PAGE = 9999;
  const WEEK = 6;

  const today = moment().format('YYYY-MM-DD');
  const futureWeek = moment().add(WEEK, 'days').format('YYYY-MM-DD');

  const response = await HttpClient.post('/orders/prolongation-statistics', {
    typeId: [],
    finishedFrom: today,
    finishedTo: futureWeek,
    isProlongList: true,
    page: FIRST_PAGE,
    limit: ITEMS_PER_PAGE,
  });

  return response.data?.data;
};
